import { Component, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { environment } from '../../../environments/environment';
import { ShortUrlService } from "../../providers/short-url.service";
import { Router, ActivationEnd, ActivatedRoute } from "@angular/router";
import { LoadingServiceProvider } from "../../providers/loading-service";
import { Location } from '@angular/common';
import { TableService } from '../../providers/table-service.service';

@Component({
  selector: 'scs-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  showMobileMenu = false;
  devEnv: boolean = !environment.production;
  version: string;
  facilities = [];
  currentClientKey: string;
  switchToClientKey: string;
  navbar: any;
  offset: any;
  currentLocationKey;
  locationData;
  initial = true;

  constructor(
    public afService: FirebaseService,
    private tableService: TableService,
    private shortUrl: ShortUrlService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private loading: LoadingServiceProvider
  ) { }

  async ngOnInit() {
    this.version = environment.version;

    await this.afService.facilitiesLoadedPromise();

    this.facilities = [];
    for (let item of this.afService.facilities) {
      this.facilities.push({ label: item.name, value: item.$key });
    }
    // When the user scrolls the page, execute myFunction
    window.onscroll = () => { this.sticky() };

    // Get the navbar
    this.navbar = document.getElementById("navbar");

    // Get the offset position of the navbar
    this.offset = this.navbar.offsetTop;

    // Activation end doesn't fire on initial pageload
    if (this.initial) {
      this.initial = false;
      this.afService.isLocation = !!this.route.snapshot.children[0].params.locKey;
      this.currentClientKey = this.route.snapshot.children[0].params.key;
      this.currentLocationKey = this.route.snapshot.children[0].params.locKey;
      this.locationData = await this.afService.getLocationInfoPromise(this.currentClientKey, this.currentLocationKey);
    }

    this.router.events
      .filter(event => event instanceof ActivationEnd)
      .subscribe(async (event: ActivationEnd) => {
        this.currentClientKey = event.snapshot.params.key;
        this.currentLocationKey = event.snapshot.params.locKey;
        this.afService.isLocation = !!event.snapshot.params.locKey;
        if (this.afService.isLocation) {
          this.locationData = await this.afService.getLocationInfoPromise(this.currentClientKey, this.currentLocationKey);
        }
        else {
          this.locationData = null;
        }
      }, (err) => {
        console.log('error in navbar watching router param:');
        console.log(err);
      });
  }

  sticky() {

    if (window.pageYOffset > this.offset) {
      this.navbar.classList.add("sticky")
    }
    else {
      this.navbar.classList.remove("sticky");
    }
  }

  changeSelectedLocation(location) {
    // this.router.navigate([`clients/${ this.afService.clientKey }/location/${ location.$key }`]);
    this.router.navigateByUrl(this.router.url.replace(this.currentLocationKey, location.$key));
  }

  toggleMobileMenu() {
    if (this.showMobileMenu == false) {
      this.showMobileMenu = true;
    }
    else {
      this.showMobileMenu = false;
    }
  }

  goHome() {
    this.tableService.setDefaults();
    this.router.navigate(['/']);
  }

  goToClient() {
    // console.log(this.currentClientKey);
    console.log(this.location.path());
    let url = this.location.path().replace(this.currentClientKey, this.switchToClientKey);
    this.router.navigate([url]);
  }

  goToPugglStats() {
    this.loading.showLoading();
    this.shortUrl.getStats().toPromise().then((stats) => {
      this.shortUrl.stats = stats;
      for (let stat in stats) {
        this.shortUrl.statsByShortLink[stats[stat].shortUrl] = stats[stat];
      }
      this.loading.hideLoading();
      this.router.navigate(['puggl-stats']);
    }).catch(e => {
      console.log(e);
      this.loading.hideLoading();
    });
  }

  goToEmailTracker() {

    this.router.navigate(['email-tracker-stats']);

  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/navbar/navbar.component.ts